<template>
  <div class="vx-card">
    <div class="flex justify-between" style="padding: 1.5rem;">
      <div class="font-bold" style="font-size: 14px;"><i class="dot" /> 안전보건 교육 미이행 현황</div>
      <div @click="moveDetailPage" class="cursor-pointer" style="color: rgba(var(--vs-primary),1);  font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;">자세히 보기 <feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></div>
    </div>
    <div class="flex justify-start" style="padding: 1.5rem;">
      <vs-tabs v-model="tabIndex">
        <!--정기안전교육, 채용시 안전교육, 작업내용 변경시 안전교육-->
        <vs-tab label="정기안전교육" />
        <vs-tab label="채용시 안전교육" />
<!--        <vs-tab label="작업내용 변경시 안전교육" />-->
      </vs-tabs>
    </div>
    <apexchart type="bar" :options="chartOptions" :series="currentSeries" height="250" />
  </div>
</template>

<script lang="ts">
export default {
  name: 'HealthSafetyEducationNotPerformedChart',
  created() {
    for (const key of Object.keys(this.allSeries)) {
      this.allSeries[key] = [...this.series];
    }
  },
  mounted() {
    this.loadApi();
  },
  data() {
    return {
      tabIndex: 0,
      fieldList: [],
      facilityCategoryByFieldId: {},
      // 퍼센트 계산을 위한, 미이행 사업장 ID 목록
      notPerformedFieldIds: [],
      // 그래프에서 추출하려고 하는 시설물 분류 값, 그 외에는 "기타"에 포함시킨다
      targetFacilityCategory: ['기계공학과', '토목공학과', '건축공학과', '법학과'],
      targetFacilityCategoryCount: {
        '기계공학과': 0,
        '토목공학과': 0,
        '건축공학과': 0,
        '법학과': 0,
        '기타': 0,
      },
      allSeries: {
        '정기안전교육': [],
        '채용시 안전교육': [],
        // '작업내용 변경시 안전교육': [],
      },
      series: [
        {
          name: '기계공학과',
          data: [0, 0, 0, 0],
        }, {
          name: '토목공학과',
          data: [0, 0, 0, 0]
        }, {
          name: '건축공학과',
          data: [0, 0, 0, 0]
        }, {
          name: '법학과',
          data: [0, 0, 0, 0]
        }, {
          name: '기타',
          data: [0, 0, 0, 0]
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 250,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['1분기', '2분기', '3분기', '4분기'],
        },
        yaxis: {
          title: {
            text: '(개소)',
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val  }개소`
            }
          }
        }
      }
    }
  },
  emits: ['update:percent', 'update:field-count'],
  computed: {
    currentSeries() {
      return this.allSeries[Object.keys(this.allSeries)[this.tabIndex]];
    }
  },
  methods: {
    moveDetailPage() {
      this.$router.push('/project/6/graph-detail/HealthSafetyEducationNotPerformedChart');
    },
    extractQuarterData(yearData) {
      const quarterData = [];
      for (let i = 0; i < 4; i++) {
        quarterData.push([]);
      }
      let month = 0;
      for (const monthData of yearData) {
        if (month === 0) {
          month += 1;
          continue;
        }
        const quarter = Math.floor((month - 1) / 3);
        for (const fieldId of monthData) {
          quarterData[quarter].push(fieldId);
          this.notPerformedFieldIds.push(fieldId);
        }

        month += 1;
      }

      const resultSeries = JSON.parse(JSON.stringify(this.series));
      for (let quarterIndex = 0; quarterIndex < 4; quarterIndex++) {
        const quarter = [...new Set(quarterData[quarterIndex])];

        for (const fieldId of quarter) {
          const cat3 = this.facilityCategoryByFieldId[fieldId];
          for (const series of resultSeries) {
            if (series.name === cat3) {
              series.data[quarterIndex] += 1;
              break;
            }
          }
        }
      }

      for (const series of resultSeries) {
        for (let i = 0; i < 4; i++) {
          const cat3Count = this.targetFacilityCategoryCount[series.name];
          series.data[i] = cat3Count - series.data[i];
        }
      }

      return resultSeries;
    },
    extractCumulateQuarterData(yearData) {
      const quarterData = [];
      for (let i = 0; i < 4; i++) {
        quarterData.push([]);
      }
      let month = 0;
      for (const monthData of yearData) {
        if (month === 0) {
          month += 1;
          continue;
        }
        const quarter = Math.floor((month - 1) / 3);
        for (const fieldId of monthData) {
          quarterData[quarter].push(fieldId);
          // 한번 이라도 작성됐으면, 이후의 분기에도 작성된 것으로 표시한다
          for (let i = quarter; i < 4; i++) {
            quarterData[i].push(fieldId);
            this.notPerformedFieldIds.push(fieldId);
          }
        }

        month += 1;
      }

      const resultSeries = JSON.parse(JSON.stringify(this.series));
      for (let quarterIndex = 0; quarterIndex < 4; quarterIndex++) {
        const quarter = [...new Set(quarterData[quarterIndex])];

        for (const fieldId of quarter) {
          const cat3 = this.facilityCategoryByFieldId[fieldId];
          for (const series of resultSeries) {
            if (series.name === cat3) {
              series.data[quarterIndex] += 1;
              break;
            }
          }
        }
      }

      for (const series of resultSeries) {
        for (let i = 0; i < 4; i++) {
          const cat3Count = this.targetFacilityCategoryCount[series.name];
          series.data[i] = cat3Count - series.data[i];
        }
      }

      return resultSeries;
    },
    async loadApi() {
      const data = await this.$store.dispatch('summary/LOAD_FIELD_EDUCATION_NOT_PERFORMED_HS', {
        projectIds: [6],
      });
      console.log('data', data);

      this.fieldList = data.fields;

      for (const field of this.fieldList) {
        let cat3 = field.facility_category ? field.facility_category.cat3 : '기타';
        if (!this.targetFacilityCategory.includes(cat3)) {
          cat3 = '기타';
        }
        this.facilityCategoryByFieldId[field.id] = cat3;
        this.targetFacilityCategoryCount[cat3] += 1;
      }

      const currentYear = new Date().getFullYear();

      // 정기안전교육
      const data434 = {};
      data434['정기안전교육'] = data.notPerformedFieldIds['정기안전교육'][currentYear];
      this.allSeries['정기안전교육'] = this.extractQuarterData(data434['정기안전교육']);
      console.log('data434', data434);
      data434['채용시 안전교육'] = data.notPerformedFieldIds['채용시 안전교육'][currentYear];
      this.allSeries['채용시 안전교육'] = this.extractCumulateQuarterData(data434['채용시 안전교육']);
      data434['작업내용 변경시 안전교육'] = data.notPerformedFieldIds['작업내용 변경시 안전교육'][currentYear];
      this.allSeries['작업내용 변경시 안전교육'] = this.extractCumulateQuarterData(data434['작업내용 변경시 안전교육']);

      // 퍼센트 계산
      const fieldCount = this.fieldList.length;
      // this.notPerformedFieldIds 중복 제거
      this.notPerformedFieldIds = [...new Set(this.notPerformedFieldIds)];
      const notPerformedFieldCount = this.notPerformedFieldIds.length;
      const percent = 100 - Math.round((notPerformedFieldCount / fieldCount) * 100);
      this.$emit('update:field-count', fieldCount);
      this.$emit('update:percent', percent);
    }
  }
}
</script>

<style scoped>

</style>
